import { useState } from 'react'

import { useDispatch } from 'react-redux'

import { Text } from '@chakra-ui/react'

import { ResolutionContent } from '@/graphql/generated/schemas'
import {
  closeSOPIncidentDrawer,
  openTraceLogDrawerWithHighlight,
  toggleIncidentTraceLogDrawer,
} from '@/redux/ui/uiSlice'

import { DEFAULT_CHAR_LIMIT } from '../utils/utils'
import { ResolutionSegments } from './ResolutionSegments'
import { ShowMoreButton } from './ShowMoreButton'

interface ResolutionContentItemIProps {
  content: ResolutionContent
  characterLimit?: number
  handleShowMore?: () => void
  handleShowLess?: () => void
}

export const ResolutionContentItem = ({
  content,
  characterLimit = DEFAULT_CHAR_LIMIT,
  handleShowMore,
  handleShowLess,
}: ResolutionContentItemIProps) => {
  const dispatch = useDispatch()
  const [isExpanded, setExpanded] = useState(false)
  const shouldTruncate = content.plainText.length > characterLimit

  const handleEventRefClick = (detectedAt: string, externalId: string) => {
    dispatch(closeSOPIncidentDrawer())
    dispatch(openTraceLogDrawerWithHighlight({ detectedAt, externalId }))
  }

  const openTraceLogDrawer = () => {
    dispatch(closeSOPIncidentDrawer())
    dispatch(toggleIncidentTraceLogDrawer())
  }

  return (
    <>
      <Text as='span' lineHeight='28px' whiteSpace='pre-line'>
        <ResolutionSegments
          characterLimit={characterLimit}
          isExpanded={isExpanded}
          onEventRefClick={handleEventRefClick}
          onOpenTraceLog={openTraceLogDrawer}
          segments={content.segments}
          shouldTruncate={shouldTruncate}
        />
      </Text>
      {shouldTruncate && (
        <ShowMoreButton
          isExpanded={isExpanded}
          onClick={() => {
            isExpanded ? handleShowLess?.() : handleShowMore?.()
            setExpanded((prev) => !prev)
          }}
        />
      )}
    </>
  )
}
